import {
	isConfigRequired,
	merge,
} from './utils';

const defaultConfigs = {
	baseUrl: '',
	method: 'GET',
	fetcher: undefined,
	responseType: 'blob',
};

function generateFileDownloadFetcher(initialConfigs = {}) {
	const _defaults = merge(defaultConfigs, initialConfigs);
	const {
		fetcher: _fetcher = isConfigRequired('fetcher'),
	} = _defaults;
	// Generate handlers by method
	const handlers = {};
	const _request = configs => {
		const finalConfigs = merge({}, _defaults, configs);

		return _fetcher(finalConfigs);
	};

	handlers.get = (url, configs = {}, timeStamp = Date.now()) => {
		return _request(merge(configs, {
			url,
			method: 'GET',
			queries: merge({}, configs.queries, { _t: timeStamp }),
		}));
	};

	return handlers;
}

export default generateFileDownloadFetcher;
